/** @format */
import React from 'react';
import TextField from '@mui/material/TextField';
import { phrases, validator } from 'myValidation';
import { Controller } from 'react-hook-form';
import get from 'lodash/get';

const InputV = ({
  name,
  defaultValue = '',
  register,
  required = false,
  errors,
  rules,
  label,
  control,
  setValue,
  ...rest
}) => {
  const vv = {};

  if (!label) {
    let nameField = name;

    if (name.includes('[')) {
      nameField = name.split('[')[0];
    }

    if (name.includes('.')) {
      nameField = `${nameField}.${name.split('.').pop()}`;
    }

    label = phrases.attributes[nameField.replace(/\s*\[.*?\]\s*/g, '')];
  }

  const hasErrorFunc = (name) => {
    if (!rules) {
      return false;
    }

    return get(errors, name, false);
  };

  const hasError = hasErrorFunc(name);

  if (rules) {
    rules.forEach((item) => {
      // with options
      if (item.includes('|')) {
        let [funcName, options] = item.split('|');
        const func = validator.validators[funcName];

        if (options.includes('{')) {
          options = JSON.parse(options);
        }

        vv[item] = (value) => {
          if (!func(value, options)) {
            return phrases[funcName].replace(':attribute', label).replace(':param', options);
          }
          return true;
        };
      } else {
        const func = validator.validators[item];
        vv[item] = (value) =>
          !func(String(value)) ? phrases[item].replace(':attribute', label) : true;
      }
    });
  }

  return (
    <>
      {register ? (
        <Controller
          control={control}
          render={({ field: { onChange, value, onBlur, ref } }) => (
            <TextField
              inputRef={ref}
              required={required}
              name={name}
              label={label}
              {...rest}
              error={!!hasError}
              helperText={hasError?.message}
              value={value}
              variant="outlined"
              onChange={(value) => onChange(value)}
            />
          )}
          name={name}
          defaultValue={defaultValue}
          rules={{
            validate: {
              ...vv,
            },
          }}
        />
      ) : (
        <TextField
          label={label}
          {...rest}
          defaultValue={defaultValue}
          error={!!errors?.[name]}
          helperText={hasError?.message}
          name={name}
          variant="outlined"
        />
      )}
    </>
  );
};

export default InputV;
